<button
  #abstractReferenceId
  *ngIf="hasStyle('raised')"
  mat-raised-button
  [color]="color"
  [type]="type"
  [disabled]="isDisabled()"
>
  <span class="d-flex justify-content-center align-items-center">
    <mat-spinner *ngIf="loading" class="mr-1" diameter="20"></mat-spinner>
    <mat-icon *ngIf="matIcon" inline="true">{{ matIcon }}</mat-icon>
    {{ label }}
  </span>
</button>
<button
  #abstractReferenceId
  *ngIf="hasStyle('stroked')"
  mat-stroked-button
  [color]="color"
  [type]="type"
  [disabled]="isDisabled()"
>
  <span class="d-flex justify-content-center align-items-center">
    <mat-spinner *ngIf="loading" class="mr-1" diameter="20"></mat-spinner>
    <mat-icon *ngIf="matIcon" inline="true">{{ matIcon }}</mat-icon>
    {{ label }}
  </span>
</button>
